import React, { useState } from "react";
import { Drawer, Button } from "@mui/material";
import FloatingList from "./FloatingElement";

const ParallelDrawer = ({ width, anchor, fullHeight, children, open, anchorParentRef }) => {
  console.log("wididid", width);
  return (
    <FloatingList zIndex={1200} margin={5} yMargin={0} anchorParentRef={anchorParentRef} isParentHight>
      <div
        style={{ maxWidth: width, minWidth: width }}
        className={`${fullHeight ? "h-screen" : "h-full"} flex flex-col shadow-9  transform transition-transform duration-500 ease-in-out bg-white ${
          open ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        } `}
      >
        {children}
      </div>
    </FloatingList>
  );
};

export default ParallelDrawer;
